import { Box } from '@locus-taxy/encore-mui';
import type { SidebarSlotProps } from '@locus-taxy/encore-mui';
import { getTestId } from '@locus-taxy/encore-utils';
import { useTranslation } from '@locus-taxy/encore-i18n-toolkit';
import TeamSelect from '../TeamSelect';
import { useEntityMetadata } from '../../api/endpoints/useEntityMetadata';
import { useClientId } from '../../hooks/useClientId';
import { useCurrentEntityName } from '../../hooks/useCurrentEntityName';
import Logo from '../../assets/Logo.svg?url';

export default function AppTitle({ mini: _mini }: Readonly<SidebarSlotProps>) {
  const clientId = useClientId();
  const { t } = useTranslation();
  const entityName = useCurrentEntityName();

  const { data: metadataResponse } = useEntityMetadata(clientId, entityName);

  const applyTeamFilter =
    metadataResponse?.data?.frontend?.gridView?.applyTeamFilter;
  const showTeamFilter = applyTeamFilter !== false;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <Box
        component="img"
        src={Logo}
        alt={t('sidebar.encoreLogoAlt')}
        sx={{ height: 20, verticalAlign: 'middle' }}
        data-testid={getTestId({
          action: 'view',
          object: 'image',
          entity: 'locus-logo',
          page: 'page-header',
        })}
      />
      {showTeamFilter && <TeamSelect />}
    </Box>
  );
}
